<template>
    <div>
        <ul class="mvt-nearbyvideo" v-if="!!getVideos?.length">
            <li v-for="(item, i) in getVideos" :key="item.id" v-once>
                <div class="video" :id="`${vnumber}_${i}`" :data-index="i" :data-id="item.id"></div>
            </li>
        </ul>
    </div>
</template>
<script src="./mvt-nearbyvideo.js"></script>
<style lang="scss">
@use './mvt-nearbyvideo.scss' as *;
</style>